// Sprint 7.3 — ConfirmHintPage (Bestätigungsseite, gezeigt direkt NACH dem Form-Submit).
// KT redirected nach erfolgreichem signin.html → /bestaetige-deine-email?k=...
// Im aktuellen Flow zeigt unsere LoginModal bereits die Success-Box "Check dein Postfach";
// diese Seite ist ein Fallback für externe KT-Formulare (zukünftige Embeds, Smart-Bar, …).

import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Mail, Inbox } from "lucide-react";
import { BRAND } from "@/config/brand";

export default function ConfirmHintPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  // k ist optional — wir personalisieren nicht im MVP, könnte später via KT-API
  // den Vornamen laden. Kommentar belassen für Sprint 7.4.
  const hasKey = Boolean(params.get("k"));

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-slate-100 p-8 sm:p-10 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-black text-white text-3xl font-black mx-auto mb-3" data-testid="confirm-hint-brand-mark">
          4
        </div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-8">
          {BRAND.name}
        </p>

        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-blue-50 text-blue-600 mx-auto mb-4">
          <Mail className="w-7 h-7" />
        </div>

        <h1
          className="text-2xl font-extrabold text-slate-900 tracking-tight"
          data-testid="confirm-hint-headline"
        >
          Fast geschafft!
        </h1>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed">
          Wir haben dir gerade eine E-Mail geschickt. Klick auf den Bestätigungs-Link darin — danach landest du direkt in deinem PocketCoach.
        </p>

        <div className="mt-6 rounded-xl bg-slate-50 border border-slate-100 p-4 text-left">
          <div className="flex items-start gap-3">
            <Inbox className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-semibold text-slate-800">
                Mail nicht im Postfach?
              </p>
              <p className="mt-1 text-xs text-slate-500 leading-relaxed">
                Schau in den Spam- oder Werbung-Ordner. Manche Mail-Anbieter brauchen eine Minute, bis die Mail durchkommt.
              </p>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={() => navigate("/")}
          data-testid="confirm-hint-home"
          className="mt-7 inline-flex items-center justify-center px-5 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800 transition-colors"
        >
          Zur Startseite
        </button>

        {hasKey && (
          <p className="mt-5 text-[10px] text-slate-300" data-testid="confirm-hint-key-debug">
            Session-Track aktiv
          </p>
        )}
      </div>
    </div>
  );
}
